import { getRelationsPairId } from "@/components/features/User/ChangeAddress/components/RequestAddressChangeForm/RequestAddressChangeForm";
import { CustomPersonalDetailsRequest } from "@/components/features/User/PolicyholderDetailPage/formType";
import { DataSchemaRaw, FieldType } from "@/components/organisms/Forms/ProfileFormPanel/utils";
import { fakeI18n } from "@/i18n";
import { Reference } from "@/shared/domain";
import * as tagManager from "@/tagManager";
import { AddressMaxLength } from "@/validations/address";

export const generalDetailsSchema = [
    {
        id: "personalTitle",
        type: FieldType.PairId,
        reference: Reference.PersonTitle,
        label: fakeI18n.t("Common.Title"),
        size: "100%",
        required: true,
    },
    {
        id: "lastName",
        type: FieldType.String,
        label: fakeI18n.t("Common.Name"),
        size: "50%",
        required: true,
    },
    {
        id: "firstName",
        type: FieldType.String,
        label: fakeI18n.t("Common.FirstName"),
        size: "50%",
        required: true,
    },
    {
        id: "gender",
        type: FieldType.PairId,
        reference: Reference.Gender,
        label: fakeI18n.t("Common.Gender"),
        required: true,
        size: "100%",
    },

    {
        id: "birthdate",
        type: FieldType.Date,
        label: fakeI18n.t("Common.BirthDate"),
        size: "100%",
    },
    {
        id: "birthPlace",
        type: FieldType.String,
        label: fakeI18n.t("Common.BirthPlace"),
        size: "100%",
    },
    {
        id: "maritalStatus",
        type: FieldType.PairId,
        reference: Reference.MaritalStatus,
        label: fakeI18n.t("Common.CivilStatus"),
        size: "50%",
        required: true,
    },
    {
        id: "nationality",
        type: FieldType.PairId,
        reference: Reference.Nationality,
        label: fakeI18n.t("Common.Nationality"),
        size: "50%",
    },
    {
        id: "language",
        type: FieldType.PairId,
        reference: Reference.Languages,
        label: fakeI18n.t("Common.Language"),
        required: true,
        size: "100%",
    },
] as DataSchemaRaw[];

export const generalCompanyDetailsSchema = [
    {
        id: "personalTitle",
        type: FieldType.PairId,
        reference: Reference.PersonTitle,
        label: fakeI18n.t("Common.Title"),
        required: true,
    },
    {
        id: "lastName",
        type: FieldType.String,
        label: fakeI18n.t("Common.Name"),
        size: "50%",
        required: true,
    },
    {
        id: "firstName",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.GeneralInformation.AdditionalName"),
        size: "50%",
    },
    {
        id: "fullDossier",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.GeneralInformation.FileNumber"),
        size: "50%",
        readMode: true,
    },
    {
        id: "foundationDate",
        type: FieldType.Date,
        label: fakeI18n.t("Common.FoundationDate"),
        size: "50%",
    },
    {
        id: "legalStatus",
        type: FieldType.PairId,
        reference: Reference.LegalStatus,
        label: fakeI18n.t("Common.LegalStatus"),
        size: "50%",
    },
    {
        id: "nationality",
        type: FieldType.PairId,
        reference: Reference.Nationality,
        label: fakeI18n.t("Common.Nationality"),
        size: "50%",
    },
    {
        id: "language",
        type: FieldType.PairId,
        reference: Reference.Languages,
        label: fakeI18n.t("Common.Language"),
        required: true,
        size: "50%",
    },
] as DataSchemaRaw[];

export const driverLicenseAndIdSchema = [
    {
        id: "identityCard-nationalNumber",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.Identity.NationalNumber"),
    },
    {
        id: "identityCard-number",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.Identity.Number"),
        size: "50%",
    },
    {
        id: "identityCard-validFrom",
        type: FieldType.Date,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.Identity.ValidFrom"),
        size: "50%",
    },
    {
        id: "identityCard-validTo",
        type: FieldType.Date,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.Identity.ValidTo"),
        size: "50%",
    },
    {
        id: "identityCard-issuedBy",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssuedBy"),
        size: "50%",
    },
    {
        id: "driversLicense-number",
        type: FieldType.String,
        label: fakeI18n.t("Common.DriverLicenseNumber"),
        size: "50%",
    },
    {
        id: "driversLicense-issueDate",
        type: FieldType.Date,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssueDate"),
        size: "50%",
    },
    {
        id: "driversLicense-type",
        type: FieldType.PairId,
        reference: Reference.DriverLicenseType,
        label: fakeI18n.t("Common.Type"),
        size: "50%",
    },
    {
        id: "driversLicense-issueCountry",
        type: FieldType.PairId,
        reference: Reference.Country,
        label: fakeI18n.t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssueCountry"),
        size: "50%",
    },
] as DataSchemaRaw[];

export const financeSchema = [
    {
        id: "bankAccount-type",
        type: FieldType.PairId,
        reference: Reference.BankAccountType,
        label: fakeI18n.t("Common.Type"),
        size: "50%",
    },
    {
        id: "bankAccount-number",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.Finance.Number"),
        size: "50%",
    },
] as DataSchemaRaw[];

export const commercialSchema = [
    {
        id: "commercialDelegate",
        type: FieldType.String,
        label: fakeI18n.t("Common.Name"),
    },
] as DataSchemaRaw[];

export const professionSchema = [
    {
        id: "profession-socialStatus",
        type: FieldType.PairId,
        reference: Reference.SocialStatus,
        label: fakeI18n.t("Common.SocialStatus"),
        size: "50%",
    },
    {
        id: "profession-taxStatus",
        type: FieldType.PairId,
        reference: Reference.TaxStatus,
        label: fakeI18n.t("Common.FiscalStatus"),
        size: "50%",
    },
    {
        id: "profession-additionalTaxStatus",
        type: FieldType.PairId,
        reference: Reference.AdditionalTaxStatus,
        label: fakeI18n.t("Common.AdditionalTaxStatus"),
        size: "50%",
    },
    {
        id: "profession-inamiNumber",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.Profession.InamiNumber"),
        size: "50%",
    },
] as DataSchemaRaw[];

export const administrationSchema = [
    {
        id: "administrator-name",
        type: FieldType.String,
        label: fakeI18n.t("Common.Name"),
        size: "50%",
    },
    {
        id: "administrator-email",
        type: FieldType.String,
        label: fakeI18n.t("Common.Email"),
        size: "50%",
    },
    {
        id: "administrator-phone",
        type: FieldType.String,
        label: fakeI18n.t("Common.Phone"),
        size: "50%",
    },
] as DataSchemaRaw[];

export const financeCompanySchema = [
    {
        id: "bankAccount-type",
        type: FieldType.PairId,
        reference: Reference.BankAccountType,
        label: fakeI18n.t("Common.Type"),
        size: "50%",
    },
    {
        id: "bankAccount-number",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.Finance.Number"),
        size: "50%",
    },
    {
        id: "bankAccount-vatNumber",
        type: FieldType.String,
        label: fakeI18n.t("Common.VatNumber"),
        size: "50%",
    },
    {
        id: "bankAccount-idCrossedDbForBusinesses",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.Finance.IdCrossedDbForBusinesses"),
        size: "50%",
    },
    {
        id: "bankAccount-establishmentNumber",
        type: FieldType.String,
        label: fakeI18n.t("User.PersonalDetails.Finance.EstablishmentNumber"),
        size: "50%",
    },
] as DataSchemaRaw[];

export const contactSchema = [
    {
        id: "contact-typePhone0",
        type: FieldType.PairId,
        reference: Reference.PhoneNumberType,
        label: fakeI18n.t("Common.Phone"),
        group: "phone-0",
        size: "25%",
    },
    {
        id: "contact-phone0",
        type: FieldType.Phone,
        label: " ",
        group: "phone-0",
    },
    {
        id: "contact-typePhone1",
        type: FieldType.PairId,
        reference: Reference.PhoneNumberType,
        group: "phone-1",
        size: "25%",
    },
    {
        id: "contact-phone1",
        type: FieldType.Phone,
        group: "phone-1",
        rule: [],
    },
    {
        id: "contact-typePhone2",
        type: FieldType.PairId,
        reference: Reference.PhoneNumberType,
        group: "phone-2",
        size: "25%",
    },
    {
        id: "contact-phone2",
        type: FieldType.Phone,
        group: "phone-2",
    },
    {
        id: "contact-email0",
        type: FieldType.String,
        group: "email-0",
        label: fakeI18n.t("Common.Email"),
    },
    {
        id: "contact-email1",
        group: "email-1",
        type: FieldType.String,
    },
] as DataSchemaRaw[];

export const addressSchema = (relations: MyBrokerApi.FamilyMember[]): DataSchemaRaw[] => {
    const schema: DataSchemaRaw[] = [
        {
            id: "mainAddress",
            type: FieldType.String,
            label: fakeI18n.t("Common.Address"),
            group: "address-0",
            size: "50%",
            required: true,
            maxLength: AddressMaxLength.Street,
        },
        {
            id: "additionalAddress",
            type: FieldType.String,
            label: fakeI18n.t("Common.AdditionalAddress"),
            group: "address-0",
            maxLength: AddressMaxLength.AdditionalAddress,
            size: "50%",
        },
        {
            id: "number",
            type: FieldType.String,
            label: fakeI18n.t("Common.Number"),
            group: "address-0",
            size: "50%",
            maxLength: AddressMaxLength.HouseNumber,
            required: true,
        },
        {
            id: "mailBox",
            type: FieldType.String,
            label: fakeI18n.t("Common.Box"),
            group: "address-0",
            maxLength: AddressMaxLength.MailBox,
            size: "50%",
        },
        {
            id: "postCode",
            type: FieldType.String,
            label: fakeI18n.t("Common.PostalCode"),
            group: "address-0",
            size: "50%",
            maxLength: AddressMaxLength.ZipCode,
            required: true,
        },
        {
            id: "city",
            type: FieldType.String,
            label: fakeI18n.t("Common.City"),
            group: "address-0",
            maxLength: AddressMaxLength.City,
            size: "50%",
            required: true,
        },
        {
            id: "country",
            type: FieldType.PairId,
            reference: Reference.Country,
            label: fakeI18n.t("Common.Country"),
            group: "address-0",
            size: "50%",
            required: true,
        },
    ];

    if (relations.length) {
        schema.push({
            id: "concerning",
            type: FieldType.MultiSelect,
            options: getRelationsPairId(relations),
            label: fakeI18n.t("User.RequestAddressChange.Concerned.Text"),
            hideRead: true,
        });
    }

    return schema;
};

export interface FormDetails {
    id: tagManager.TMFormEditId;
    name: tagManager.TMFormEditName;
}

export enum PersonalDetailsAreas {
    GENERAL_INFO = "generalInfo",
    IDENTITY_AND_DRIVER_LICENSE = "identityAndDriverLicense",
    CONTACT = "contact",
    PROFESSION = "profession",
    FINANCE = "finance",
}

export const mapPolicyholderRequest = (
    policyholderDetailRequest: MyBrokerApi.PolicyHolderPersonalDetails,
): CustomPersonalDetailsRequest => ({
    ...policyholderDetailRequest,
    fullDossier: [policyholderDetailRequest.dossier, policyholderDetailRequest.subDossier]
        .filter((e) => !!e.toString())
        .join("/"),
});

export const getFormDetailByArea = (detailArea: PersonalDetailsAreas): FormDetails => {
    switch (detailArea) {
        case PersonalDetailsAreas.CONTACT:
            return { id: "contact", name: "Contact" };
        case PersonalDetailsAreas.FINANCE:
            return { id: "finance", name: "Finance" };
        case PersonalDetailsAreas.GENERAL_INFO:
            return { id: "general_information", name: "General Information" };
        case PersonalDetailsAreas.IDENTITY_AND_DRIVER_LICENSE:
            return { id: "driver_license_and_id", name: "Driver License and Id" };
        case PersonalDetailsAreas.PROFESSION:
            return { id: "profession", name: "Profession" };

        default:
            return { id: null, name: null };
    }
};
